import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'
import app from './modules/app'
import bible from './modules/bible'
import profile from './modules/profile'
import auth from './modules/auth'
import user from './modules/user'
import inventory from './modules/inventory'
import store from './modules/store'
import item from './modules/item'
import item_cache from './modules/item_cache'
import answer from './modules/answer'
import calendar from './modules/calendar'
import user_log from './modules/user_log'
import notification from './modules/notification'
import setting from './modules/setting'
import axios from './modules/axios'

Vue.use(Vuex)

const vuex = new Vuex.Store({
    modules: {
        app,
        bible,
        profile,
        axios,
        auth,
        user,
        inventory,
        store,
        item,
        item_cache,
        calendar,
        user_log,
        answer,
        notification,
        setting,
    },
    getters
})

export default vuex

